import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import ViewRow from './MailViewRow';
import BtnGradient from '../common/button/BtnGradient';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import BtnOutlineGradient from '../common/button/BtnOutlineGradient';

const MailView = (props: any) => {
  const navigate = useNavigate();
  const handleEditClick = () => {
    navigate(`/master/email-edit?id=${props.email.id}`);
  };

  const handleCancel = () => {
    navigate(`/master/email`);
  };

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: 'none',
          width: '100%',
          height: '100%',
        }}
      >
        <Table
          sx={{
            minWidth: 470,
            '& .MuiTableCell-root.MuiTableCell-head': {
              borderBottom: '1px solid #F3F3F3',
              fontWeight: 700,
              p: '6px 16px',
              fontSize: '14px',
            },
            '& .MuiTableCell-root.MuiTableCell-body': {
              color: 'primary.dark',
              fontSize: '14px',
              py: '6px',
            },
          }}
          aria-label='simple table'
        >
          <TableBody sx={{ '&.MuiTableBody-root th': { fontWeight: 700 } }}>
            <ViewRow
              title='テンプレート名'
              content={props.email ? props.email.name : ''}
            />
            <ViewRow
              title='カテゴリー'
              content={props.email ? props.email.category : ''}
            />
            <ViewRow
              title='最終更新日'
              content={props.email ? props.email.updated_at : ''}
            />
            <ViewRow
              title='件名'
              content={props.email ? props.email.contents.subject : ''}
            />
            <ViewRow
              title='本文'
              content={props.email ? props.email.contents.body : ''}
            />
          </TableBody>
        </Table>
      </TableContainer>
      <Stack direction={'row'} spacing={'20px'} mt={'32px'}>
        <BtnOutlineGradient
          text='キャンセル'
          handleButtonClick={handleCancel}
        />
        <BtnGradient text='更新' handleButtonClick={handleEditClick} />
      </Stack>
    </>
  );
};

export default MailView;
